import _ from 'lodash';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { WppCard, WppCardGroup, WppTypography } from 'buildingBlocks';
import { BULK_CREATE_MAX_FLIGHTS_ALLOWED, UploadOptions } from 'containers/BulkCreateStrategyWizard/steps/AttachFlights/constants';
import { bulkUploaderStyles } from 'containers/BulkCreateStrategyWizard/steps/AttachFlights/style';
import { isSameMemberFlightsAdded } from 'containers/BulkCreateStrategyWizard/steps/AttachFlights/utils';
import { useBulkCreateAttachModalContext } from 'containers/BulkCreateStrategyWizard/steps/AttachFlights/contexts/BulkCreateAttachModalProvider';

const { uploadOptionsStyle, uploadOptionsContainer } = bulkUploaderStyles;

type Props = {
  flightAttachOption: string
  setFlightAttachOption: (x: string) => void
  bulkFlightIds: Array<number | string>
};

const FlightAttachOptions = (props: Props) => {
  const { flightAttachOption, setFlightAttachOption, bulkFlightIds } = props;
  const { flightCandidateInfo: { flightCandidates } } = useBulkCreateAttachModalContext();
  const attachedFlights = useWatch({ name: 'attachedFlights' });
  const bulkUploadId = _.first(bulkFlightIds);
  const selectedFlight = _.find(flightCandidates, (flight) => flight.externalId === bulkUploadId);
  const sameMemberFlightsAdded = isSameMemberFlightsAdded(_.first(attachedFlights), selectedFlight);
  const disableAddToSelection = !sameMemberFlightsAdded || (_.size(attachedFlights) + _.size(bulkFlightIds) > BULK_CREATE_MAX_FLIGHTS_ALLOWED);

  const handleClick = (event) => {
    setFlightAttachOption(event.detail.value);
  };

  return (
    <>
      <WppTypography type="s-body" tag="h3">
        You already have objects selected. Would you like to replace them or add more?
      </WppTypography>
      <WppCardGroup
        value={flightAttachOption}
        withRadioOrCheckbox
        onWppChange={handleClick}
        style={uploadOptionsContainer}
      >
        <WppCard value={UploadOptions.replaceSelection} style={uploadOptionsStyle}>
          <WppTypography slot="header" type="m-strong">
            {_.startCase(UploadOptions.replaceSelection)}
          </WppTypography>
          <WppTypography type="xs-body">
            This will clear your current selection and use objects from the file instead.
            This action cannot be undone.
          </WppTypography>
        </WppCard>
        <WppCard
          value={UploadOptions.addToSelection}
          style={uploadOptionsStyle}
          disabled={disableAddToSelection}
        >
          <WppTypography slot="header" type="m-strong">
            {_.startCase(UploadOptions.addToSelection)}
          </WppTypography>
          <WppTypography type="xs-body">
            This will keep your current selection and add any new items from the file.
          </WppTypography>
        </WppCard>
      </WppCardGroup>
    </>
  );
};

export default FlightAttachOptions;
